import parameters from "./parameters";
import schemas from "./schemas";
import securitySchemes from "./securitySchemes";
import responses from "./responses";
import requestBodies from "./requestBodies";

export default {
  parameters,
  schemas,
  securitySchemes,
  responses,
  requestBodies
};
